export const Currency = {
    EUR: 978,
    CHF: 756,
    PLN: 985
}

export const CashlessJobs = {
    cashless_config_job: 'Reconfigure Cashless Device',
    diagnosis_job: 'Download latest Bank config',
    initialization_job: 'Initialization',
    update_firmware: 'Update Firmware to latest available version'
}
